<template>
    <div class="wfh-loader-page">
        <div class="lds-default">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loader',
}
</script>

<style scoped lang="scss">
    .wfh-loader-page {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
    }
</style>

